import Vue from 'vue';
import { mapActions, mapState, mapGetters } from 'vuex';
import { i18n } from 'lib/i18n.js';
import { decode } from 'utils/general';
import bus from 'lib/bus';
import { pushDataSignup } from 'lib/tracking';
import { trackEvent } from '../../assets/js/lib/tracking';

let i = 0;

export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    'product-shade': () => import('../product-shade/product-shade.vue'),
    'product-use': () => import('../product-use/product-use.vue'),
    'product-set-item': () => import('../product-set/product-set-item.vue'),
    'product-video': () => import('../product-video/product-video.vue'),
    modal: () => import('../modal/modal.vue'),
  },
  props: {
    accordionId: { type: String },
    accordionClass: { type: String },
    titleClass: { type: String },
    title: { type: String },
    title_number: { type: String },
    contentClass: { type: String },
    content: { type: String },
    initiallyCollapsed: { type: Boolean, default: true },
    trackingPdp: { type: Boolean, default: true }
  },
  i18n,
  data() {
    return {
      isActive: false,
      i: i++,
      readMoreVisible: false,
      hasContent: true,
    };
  },
  mounted() {
    this.isActive = !this.initiallyCollapsed;
    bus.$on(`open-${this.accordionId}-accordion`, () => {
      this.isActive = true;
    });
    if (!this.content) {
      this.hasContent = false;
    }
  },
  computed: {
    ...mapGetters('product', ['productTitle']),
    ...mapState('product', ['product']),
    isOpen() {
      if (!this.isActive) {
        return 'hidden';
      }
      return 'visible';
    },
    height() {
      if (!this.isActive) {
        return 0;
      }
      return 'unset';
    },
    openText() {
      return `${this.$t('general.actions.open')} ${this.title}`;
    },
    closeText() {
      return `${this.$t('general.actions.close')} ${this.title}`;
    },
    contentDecoded() {
      return decode(this.content);
    },
    readMoreButtonText() {
      return this.readMoreVisible
        ? this.$t('products.details.read_less')
        : this.$t('products.details.read_more');
    },
    seeFullIngredientsText() {
      return this.$t('products.ingredients.see_full_ingredients');
    },
    accordionTitle() {
      if (!title_number) return title;
      return `<div class="accordion__title-wrapper"><span class="accordion__num">${title_number}</span><span>${title}</span></div>`;
    },
  },
  methods: {
    ...mapActions('global', ['openModal', 'closeModal']),
    toggle(event) {
      this.isActive = !this.isActive;
      const origin = document.body.getAttribute('data-origin');
      if (this.isActive && origin === 'LP') {
        const param = {
          event: 'faqs_click',
          click_text: event.currentTarget.firstChild.innerText,
        };
        pushDataSignup(param);
      }

      this.$emit('toggle', this);
      if (origin === 'PDP' && this.trackingPdp) {
        this.handleTracking();
      }
    },
    handleTracking() {
      const product_title = document.body.getAttribute('data-product');
      trackEvent({
        event: 'product_module_interaction',
        click_action: this.isActive ? 'expand' : 'collapse', // this.isActive is the new state (after user clicks)
        section_name: this.title.toLowerCase(),
        product_name: product_title || this.productTitle,
        module_name: 'product accordion',
        shopify_module_name: 'accordion'
      });
    },
    modalButtonClickHandler(e) {
      this.openModal(e.target.dataset.modalHandle);
    },
    readMoreButtonClickHandler() {
      this.readMoreVisible = !this.readMoreVisible;
    },
  },
  template: `
  <div
    class="accordion"
    :id="[accordionId]"
    :class="[accordionClass, {'is-active': isActive}]">
    <div>
      <h2>
        <button
          v-if="hasContent"
          class="accordion__title block w1 align-l relative"
          :class="title_class"
          @click="toggle"
          :aria-expanded="(isActive) ? 'true' : 'false'"
          :aria-controls="'accordion_' + i">
          {{ title }}
          <div class="accordion__title__icon">
          </div>
        </button>
        <div v-else
        class="accordion__title block w1 align-l relative"
        :class="title_class">
          {{ title }}
          <div class="accordion__title__icon">
          </div>
        </div>
      </h2>
      <div v-if="hasContent" class="accordion__body" :style="{maxHeight: height, visibility: isOpen}" :id="'accordion_' + i">
        <div class="accordion__body__content" :class="contentClass" ref="content">
          <div v-html="contentDecoded"></div>
          <slot v-else></slot>
        </div>
      </div>
    </div>
  </div>
  `,
};
